/**
 * Takes color that is a CSS Variable - "var(--default-bg)".
 * Returns Hex value defined in CSS Var
 */
const getCSSVariableValue = (color: string) => {
  if (!color) return "#fff"
  if (!color.startsWith("var(")) return color;

  // Cuts "var(" and ")" from CSS variable
  var colorKey = removeVarWrapperFromString(color);
  // Gets DOM styles
  var style = getComputedStyle(document.body);
  // Gets value from CSS specific variable
  var hexColor = style.getPropertyValue(String(colorKey));
  hexColor = hexColor.trim();
  return hexColor ?? color;
};

/**
 * Removes "var(" and ")" from CSS Variable
 */
export const removeVarWrapperFromString = (color: string) =>
  color.substring(4, String(color).length - 1);

export default getCSSVariableValue;
